import React, {Component} from 'react';
import {Button, Modal} from 'react-bootstrap';
import axios from 'axios';
import ContractItemsHistoryEdit from "./ContractItemsHistoryEdit";

export default class ContractItemsHistoryModal extends Component {
    constructor() {
        super();

        this.state = {
            item_id: 0,
            item_description: "",
            rows: [],
            history_id: 0,
            show_edit: false,
        };

        this.close = this.close.bind(this);
        this.getData = this.getData.bind(this);
        this.editCallback = this.editCallback.bind(this);
        this.editRow = this.editRow.bind(this);
        this.addRow = this.addRow.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.id !== undefined && nextProps.id !== 0) {
            this.setState({
                item_id: nextProps.id
            }, () => {
                this.getData();
            });
        }
    }

    getData(callback) {
        let url = "/contracts/ajax/manage_contracts/" + this.props.contractId + "/items_history/" + this.state.item_id;
        axios
            .get(url)
            .then((response) => {
                let item = response.data.item;
                let history = response.data.history;
                this.setState({
                    item_id: item.id,
                    item_description: item.description,
                    rows: history
                }, () => {
                    if (callback !== undefined) callback();
                });
            });
    }

    editCallback() {
        this.getData(() => {
            this.setState({show_edit: false});
        });
    }

    close() {
        this.props.closeCallback();
    }

    editRow(id) {
        this.setState({
            history_id: id,
            show_edit: true
        });
    }

    addRow() {
        this.setState({
            history_id: 0,
            show_edit: true
        });
    }

    deleteRow(id) {
        if (confirm(window.__js_contracts.delete_entry_verification)) {
            let url = "/contracts/ajax/manage_contracts/" + this.props.contractId + "/items_history/" + this.state.item_id + "/" + id + "/delete";
            axios
                .get(url)
                .then((response) => {
                    this.getData();
                });
        }
    }

    render() {
        let rows = [];
        let data = this.state.rows;
        if (data.length > 0) {
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    let history = data[key];
                    rows.push(
                        <tr key={history.id}>
                            <td>{history.delivery_date_formatted}</td>
                            <td>{history.quantity_formatted}</td>
                            <td>
                                <Button onClick={() => this.editRow(history.id)}
                                        bsStyle="primary"
                                        bsSize="xsmall">
                                    <i className="fa fa-pencil"></i>
                                </Button>
                                &nbsp;
                                <Button onClick={() => this.deleteRow(history.id)}
                                        bsStyle="danger"
                                        bsSize="xsmall">
                                    <i className="fa fa-trash"></i>
                                </Button>
                            </td>
                        </tr>
                    );
                }
            }
        } else {
            rows.push(
                <tr key="0">
                    <td colSpan="3">
                        <em>{window.__js_contracts.no_receipts_found}</em>
                    </td>
                </tr>
            );
        }

        return (
            <Modal show={this.props.showModal}
                   onHide={this.close}
                   bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>{window.__js_contracts.receipts_tracking}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <strong>{window.__js_contracts.item_description}:</strong> {this.state.item_description}
                        </div>
                    </div>
                    <br/>
                    <legend>{window.__js_contracts.receipts_table}</legend>
                    <Button onClick={this.addRow}
                            bsStyle="primary">
                        <i className="fa fa-plus"></i> {window.__js_contracts.add_receipt}
                    </Button>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="table-responsive">
                                <table className="table table-hover table-bordered table-striped">
                                    <thead>
                                    <tr>
                                        <th>{window.__js_general.date}</th>
                                        <th>{window.__js_contracts.quantity}</th>
                                        <th>{window.__js_contracts.actions}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {rows}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <ContractItemsHistoryEdit show={this.state.show_edit}
                                              contractId={this.props.contractId}
                                              itemId={this.state.item_id}
                                              historyId={this.state.history_id}
                                              submitCallback={this.editCallback}/>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.close}>{window.__js_general.close}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}